import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@finitless/shared/lib";
import { isEndpointEnabled } from "@finitless/shared/config";

export const useOrderDetail = (orderId) => {
  // Use React Query for caching and background updates
  return useQuery({
    queryKey: ["order", orderId],
    queryFn: async () => {
      if (!orderId) return null;

      try {
        const response = await apiClient.get(
          `/orders/${orderId}?mode=dashboard`,
        );
        return response.result;
      } catch (err) {
        throw new Error(err.message || "Failed to fetch order details");
      }
    },
    enabled: !!orderId && isEndpointEnabled("dashboard", "orders"),
    staleTime: 0, // Set to 0 so cache updates from websocket are immediately visible
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    retry: (failureCount, error) => {
      if (error?.status >= 400 && error?.status < 500) {
        return false;
      }
      return failureCount < 2;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};
